import { api } from "./api";

/**UOM */
export const uomCreateApi = (params) => {
  return api.post(`/settings/uom/add`, JSON.stringify(params));
};

export const uomUpdateApi = (params) => {
  return api.post(`/settings/uom/update`, JSON.stringify(params));
};

export const uomListApi = (params) => {
  return api.get(`/settings/uom/list`, { params: params });
};
export const uomImportApi = (params) => {
  return api.post(`/data-setup/uom`, JSON.stringify(params));
};

/**UOM GROUPS */
export const uomGroupDataListApi = (params) => {
  return api.get(`/settings/uom-group/list`, { params: params });
};
export const uomGroupDataAddApi = (params) => {
  return api.post(`/settings/uom-group/add`, JSON.stringify(params));
};
export const uomGroupDataUpdateApi = (params) => {
  return api.post(`/settings/uom-group/update`, JSON.stringify(params));
};
export const uomGroupDeleteApi = (params) => {
  return api.post(`/settings/uom-group/delete`, JSON.stringify(params));
};
export const uomGroupItemDeleteApi = (params) => {
  return api.post(`/settings/uom-group/item-delete`, JSON.stringify(params));
};
export const uomGroupUomListApi = (params) => {
  return api.get(`/settings/uom-group/uom-list`, { params: params });
};
export const uomDropDownApi = (params) => {
  return api.get(`/settingsV2/uomDropDown`, { params: params }); //old
};

export const uomDropDownApiNew = (params) => {
  return api.get(`/settings/uomDropDown`, { params: params }); //new
};

export const uomGroupImportAddApi = (params) => {
  return api.post(
    `/data-setup/uom-group-data-and-uom-group-item`,
    JSON.stringify(params)
  );
};
export const uomGroupItemImportApi = (params) => {
  return api.post(`/data-setup/uom-group-item`, JSON.stringify(params));
};

export const uomGroupCalculationApi = (params) => {
  return api.post(`/settings/uom-group/base-qantity-calculation`, JSON.stringify(params));
};

/**Item Setup */
export const itemTypeAddApi = (params) => {
  return api.post(`/settings/item-type/add`, JSON.stringify(params));
};
export const itemTypeUpdateApi = (params) => {
  return api.post(`/settings/item-type/update`, JSON.stringify(params));
};
export const itemTypeListApi = (params) => {
  return api.get(`/settings/item-type/list`, { params: params });
};
export const itemTypeDeleteApi = (params) => {
  return api.post(`/settings/item-type/delete`, JSON.stringify(params));
};
export const itemTypeImportApi = (params) => {
  return api.post(`/data-setup/item-type`, JSON.stringify(params));
};

export const itemCategoryAddApi = (params) => {
  return api.post(`/settings/item-category/add`, JSON.stringify(params));
};
export const itemCategoryUpdateApi = (params) => {
  return api.post(`/settings/item-category/update`, JSON.stringify(params));
};
export const itemCategoryDeleteApi = (params) => {
  return api.post(`/settings/item-category/delete`, JSON.stringify(params));
};
export const itemCategoryListApi = (params) => {
  return api.get(`/settings/item-category/list`, { params: params });
};
export const itemCategoryImportApi = (params) => {
  return api.post(`/data-setup/item-category`, JSON.stringify(params));
};

export const itemGroupAddApi = (params) => {
  return api.post(`/settings/item-group/add`, JSON.stringify(params));
};
export const itemGroupUpdateApi = (params) => {
  return api.post(`/settings/item-group/update`, JSON.stringify(params));
};
export const itemGroupDeleteApi = (params) => {
  return api.post(`/settings/item-group/delete`, JSON.stringify(params));
};
export const itemGroupListApi = (params) => {
  return api.get(`/settings/item-group/list`, { params: params });
};

export const itemGroupImportApi = (params) => {
  return api.post(`/data-setup/item-group`, JSON.stringify(params));
};

/**Manufacturer setup */
export const manufacturerAddApi = (params) => {
  return api.post(`/settings/manufacturer/add`, JSON.stringify(params));
};
export const manufacturerUpdateApi = (params) => {
  return api.post(`/settings/manufacturer/update`, JSON.stringify(params));
};
export const manufacturerListApi = (params) => {
  return api.get(`/settings/manufacturer/list`, { params: params });
};
export const manufacturerDeleteApi = (params) => {
  return api.post(`/settings/manufacturer/delete`, JSON.stringify(params));
};
export const manufacturerImportApi = (params) => {
  return api.post(`/data-setup/manufacturer`, JSON.stringify(params));
};

/**Tax setup */
export const taxTypeAddApi = (params) => {
  return api.post(`/settings/tax-type/add`, JSON.stringify(params));
};
export const taxTypeUpdateApi = (params) => {
  return api.post(`/settings/tax-type/update`, JSON.stringify(params));
};
export const taxTypeDeleteApi = (params) => {
  return api.post(`/settings/tax-type/delete`, JSON.stringify(params));
};

export const taxTypeImportApi = (params) => {
  return api.post(`/data-setup/tax-type`, JSON.stringify(params));
};
export const taxTypeListApi = (params) => {
  return api.get(`/settings/tax-type/list`, { params: params });
};

export const taxCombinationAddApi = (params) => {
  // return api.post(`/settings/tax-combination/add`, JSON.stringify(params));
  return api.post(`/settings/tax-combination/v1/add`, JSON.stringify(params));
};
export const taxCombinationUpdateApi = (params) => {
  // return api.post(`/settings/tax-combination/update`, JSON.stringify(params));
  return api.post(`/settings/tax-combination/v1/update`, JSON.stringify(params));
};
export const taxCombinationListApi = (params) => {
  return api.get(`/settings/tax-combination/list`, { params: params });
};
export const taxCombinationDeleteApi = (params) => {
  return api.post(`/settings/tax-combination/delete`, JSON.stringify(params));
};
export const taxCombinationItemDeleteApi = (params) => {
  return api.post(
    `/settings/tax-combination-item/delete`,
    JSON.stringify(params)
  );
};
export const taxCombinationImportApi = (params) => {
  return api.post(`/data-setup/tax-combination-item`, JSON.stringify(params));
};
export const taxTypeDropDownApi = (params) => {
  return api.get(`/settings/tax-combination/tax-types`, { params: params });
};

/**Shipping Type */
export const shippingTypeAddApi = (params) => {
  return api.post(`/settings/shipping-type/add`, JSON.stringify(params));
};
export const shippingTypeUpdateApi = (params) => {
  return api.post(`/settings/shipping-type/update`, JSON.stringify(params));
};
export const shippingTypeDeleteApi = (params) => {
  return api.post(`/settings/shipping-type/delete`, JSON.stringify(params));
};
export const shippingTypeListApi = (params) => {
  return api.get(`/settings/shipping-type/list`, { params: params });
};

export const shippingTypeImportApi = (params) => {
  return api.post(`/data-setup/shippingtype`, JSON.stringify(params));
};

/**Document Numbering */
export const documentNumberingList = (params) => {
  return api.get(`/document/numbering/document/getAll`, { params: params });
};
export const documentNumberingUpdateApi = (params) => {
  return api.post(
    `/settings/document-numbering/update`,
    JSON.stringify(params)
  );
};

export const documentNumberingSeriesList = (params) => {
  return api.get(`/document/numbering/series/get`, { params: params });
};
export const documentNumberingSeriesAddApi = (params) => {
  return api.post(
    `/document/numbering/series/add-or-update`,
    JSON.stringify(params)
  );
  // return api.post(`/document/numbering/series/add`, JSON.stringify(params));
};
export const documentNumberingSeriesUpdateApi = (params) => {
  return api.post(
    `/settings/document-numbering-series/update`,
    JSON.stringify(params)
  );
};
/**cutom Document Numbering */
export const customNumberingList = (params) => {
  return api.get(`/document/numbering/custom/document/getAll`, {
    params: params,
  });
};
export const customNumberingUpdateApi = (params) => {
  return api.post(
    `/settings/document-numbering/update`,
    JSON.stringify(params)
  );
};

export const customNumberingSeriesList = (params) => {
  return api.get(`/document/numbering/custom/series/get`, {
    params: params,
  });
};
export const customNumberingSeriesAddApi = (params) => {
  return api.post(
    `/document/numbering/custom/series/add`,
    JSON.stringify(params)
  );
  // return api.post(`/document/numbering/series/add`, JSON.stringify(params));
};
export const customNumberingSeriesUpdateApi = (params) => {
  return api.post(
    `/settings/document-numbering-series/update`,
    JSON.stringify(params)
  );
};

/**Communication */

//SMTP
export const smtpViewApi = (params) => {
  return api.get(`/settings/smtp/view`, { params: params });
};
export const smtpAddApi = (params) => {
  return api.post(`/settings/smtp/add`, JSON.stringify(params));
};
export const smtpUpdateApi = (params) => {
  return api.post(`/settings/smtp/update`, JSON.stringify(params));
};

//Whatsapp
export const whatsappViewApi = (params) => {
  return api.get(`/settings/whatsapp/view`, { params: params });
};
export const whatsappAddApi = (params) => {
  return api.post(`/settings/whatsapp/add`, JSON.stringify(params));
};
export const whatsappUpdateApi = (params) => {
  return api.post(`/settings/whatsapp/update`, JSON.stringify(params));
};
//SMS
export const smsViewApi = (params) => {
  return api.get(`/settings/sms/view`, { params: params });
};
export const smsAddApi = (params) => {
  return api.post(`/settings/sms/add`, JSON.stringify(params));
};
export const smsUpdateApi = (params) => {
  return api.post(`/settings/sms/update`, JSON.stringify(params));
};

/**Payment Config */
//Razorpay
export const razorpayViewApi = (params) => {
  return api.get(`/settings/razorpay/view`, { params: params });
};
export const razorpayAddApi = (params) => {
  return api.post(`/settings/razorpay/add`, JSON.stringify(params));
};
export const razorpayUpdateApi = (params) => {
  return api.post(`/settings/razorpay/update`, JSON.stringify(params));
};

//Stripe
export const stripeViewApi = (params) => {
  return api.get(`/settings/stripe/view`, { params: params });
};
export const stripeAddApi = (params) => {
  return api.post(`/settings/stripe/add`, JSON.stringify(params));
};
export const stripeUpdateApi = (params) => {
  return api.post(`/settings/stripe/update`, JSON.stringify(params));
};

//Phonepe
export const phonepeViewApi = (params) => {
  return api.get(`/settings/phonepe/view`, { params: params });
};
export const phonepeAddApi = (params) => {
  return api.post(`/settings/phonepe/add`, JSON.stringify(params));
};
export const phonepeUpdateApi = (params) => {
  return api.post(`/settings/phonepe/update`, JSON.stringify(params));
};

//Paytm
export const paytmViewApi = (params) => {
  return api.get(`/settings/paytm/view`, { params: params });
};
export const paytmAddApi = (params) => {
  return api.post(`/settings/paytm/add`, JSON.stringify(params));
};
export const paytmUpdateApi = (params) => {
  return api.post(`/settings/paytm/update`, JSON.stringify(params));
};

//PineLabs
export const pineLabsViewApi = (params) => {
  return api.get(`/settings/pine-labs/view`, { params: params });
};
export const pineLabsAddApi = (params) => {
  return api.post(`/settings/pine-labs/add`, JSON.stringify(params));
};
export const pineLabsUpdateApi = (params) => {
  return api.post(`/settings/pine-labs/update`, JSON.stringify(params));
};

/**Print Preference */
export const printPreferenceListApi = (params) => {
  return api.get(`/settings/print-preference/list`, { params: params });
};
export const BillingTypesApi = (params) => {
  return api.get(`order/GetAllFormats`, { params: params });
};
export const printPreferenceUpdateApi = (params) => {
  return api.post(`/settings/print-preference/update`, JSON.stringify(params));
};
export const currentPrintPreferenceApi = (params) => {
  return api.get(`/settings/print-preference/current`, { params: params });
};

/**Print Preference */
export const storeDetailsGetApi = (params) => {
  return api.get(`/store/details/getById?store_id=${params}`);
};
export const storeDetailsUpdateApi = (params) => {
  return api.post(`/store/details/update`, JSON.stringify(params));
};

// alternativeItem setup

export const mapAlternativerItemApi = (params) => {
  return api.post(`/product/alternative/add`, JSON.stringify(params));
};
export const alternativeItemsListApi = (params) => {
  return api.get(
    `/product/alternative/getList?pageNumber=${params?.pageNumber}&pageSize=${params?.pageSize}`
  );
};
export const deleteAlternativeTransApi = (params) => {
  return api.post(`/product/alternative/delete`, JSON.stringify(params));
};
export const alternativerItemImportApi = (params) => {
  return api.post(`/data-setup/alternative-items`, JSON.stringify(params));
};
export const addCustomInvoiceApi = (params) => {
  return api.post(`/settings/adding-custom-invoice`, JSON.stringify(params));
};
/**TCS TDS setup */
export const tcsTaxCreateApi = (params) => {
  return api.post(`/settings/tax/addTcs`, JSON.stringify(params));
};

export const tcsTaxDeleteApi = (params) => {
  return api.post(`/settings/tax/tcsdelete`, JSON.stringify(params));
};
export const tcsTaxListApi = (params) => {
  return api.get(`/settings/tax/tcslist`, { params: params });
};
export const tcsTaxImportApi = (params) => {
  return api.post(`/data-setup/tcs`, JSON.stringify(params));
};
export const tdsTaxCreateApi = (params) => {
  return api.post(`/settings/tax/addTds`, JSON.stringify(params));
};

export const tdsTaxDeleteApi = (params) => {
  return api.post(`/settings/tax/tdsdelete`, JSON.stringify(params));
};
export const tdsTaxListApi = (params) => {
  return api.get(`/settings/tax/tdslist`, { params: params });
};
export const tdsTaxImportApi = (params) => {
  return api.post(`/data-setup/tds`, JSON.stringify(params));
};
export const partyListApi = (params) => {
  return api.get(`/partyCategory/list`);
};

//template api
export const templateCreateApi = (params) => {
  return api.post(`/template/create`, JSON.stringify(params));
};

export const templateTableApi = (params) => {
  return api.get(`/template/getMappingList`, { params: params });
};

export const templateViewApi = (params) => {
  return api.get(
    `/template/getMappingById?mapping_id=${params}`,
    JSON.stringify(params)
  );
};
export const templateEditApi = (params) => {
  return api.post(`/template/update`, JSON.stringify(params));
};
export const templateDeleteApi = (params) => {
  return api.post(`/template/delete`, JSON.stringify(params));
};

//department and role api

// role APIs
export const roleSearchApi = (params) => {
  if (params) {
    return api.get(`/get-role-list?search=${params}`);
  } else return api.get(`/get-role-list?search=`);
};

export const roleCreateApi = (data) => {
  return api.post(`/create-role`, data);
};

export const roleEditeApi = (data) => {
  return api.post(`/update-role`, data);
};

export const roleDeleteApi = (data) => {
  return api.post(`/delete-role`, data);
};

export const roleDocumentUploadApi = (data) => {
  return api.post(`/roles-bulk-import`, data);
};

// Department APIs

export const departmentSearchApi = (params) => {
  if (params) {
    return api.get(`/get-department-list?search=${params}`);
  } else return api.get(`/get-department-list?search=`);
};

export const departmentCreateApi = (data) => {
  return api.post(`/create-department`, data);
};

export const departmentEditeApi = (data) => {
  return api.post(`/update-department`, data);
};

export const departmentDeleteApi = (data) => {
  return api.post(`/delete-department`, data);
};

export const departmentDocumentUploadApi = (data) => {
  return api.post(`/departments-bulk-import`, data);
};

// Attached Roles to Department APIs
export const attachedRolesDepartmentCreateApi = (data) => {
  return api.post(`/roles-attach-to-department`, data);
};
export const attachedRolesDepartmentDeleteApi = (data) => {
  return api.post(`/delete-mapping-from-role-department-list`, data);
};
// Module Settings API
export const moduleSettingsGetAllApi = () => {
  return api.get("/template/getAll");
};
export const moduleSettingsUpdateApi = (params) => {
  return api.post("/template/update-setting", JSON.stringify(params));
};

export const vendorUOMMappingApi = (params) => {
  return api.post("/vendorMapping/addUOMMapping", JSON.stringify(params));
};
export const getVendorUOMMappingApi = (params) => {
  return api.post("/vendorMapping/getUOMMapping", JSON.stringify(params));
};
export const VendorMappingApi = (params) => {
  return api.post("/vendorMapping/addVendorMapping", JSON.stringify(params));
};
export const VendorTableApi = (params) => {
  return api.get("/vendorMapping/getVendorMappingData", JSON.stringify(params));
};
// DATA SETUP
export const drugSearchApi = (params) => {
  if (params) {
    return api.get(`settings/itemschedule/list/search?searchValue=${params}`);
  } else return api.get(`settings/itemschedule/list/search?searchValue=`);
};

export const drugCreateApi = (data) => {
  return api.post(`/settings/itemschedule/add`, data);
};

export const drugEditeApi = (data) => {
  return api.post(`/settings/itemschedule/update`, data);
};

export const drugDeleteApi = (data) => {
  return api.post(`/settings/itemschedule/delete`, data);
};

export const drugDocumentUploadApi = (data) => {
  return api.post(`/settings/itemschedule/add`, data);
};

//

export const genericSearchApi = (params) => {
  if (params) {
    return api.get(`/settings/generic-name/list/search?searchValue=${params}`);
  } else return api.get(`/settings/generic-name/list/search?searchValue=`);
};

export const genericCreateApi = (data) => {
  return api.post(`/settings/generic-name/add`, data);
};

export const genericEditApi = (data) => {
  return api.post(`/settings/generic-name/update`, data);
};

export const genericDeleteApi = (data) => {
  return api.post(`/settings/generic-name/delete`, data);
};

export const genericDocumentUploadApi = (data) => {
  return api.post(`/settings/generic-name/bulk/add`, data);
};

// Composition/Item Schedule APIs (same as drug)
export const compositionSearchApi = (params) => {
  if (params) {
    return api.get(`/settings/itemMolecule/list/search?searchValue=${params}`);
  } else return api.get(`/settings/itemMolecule/list/search?searchValue=`);
};

export const compositionCreateApi = (data) => {
  return api.post(`/settings/itemMolecule/add`, data);
};

export const compositionEditApi = (data) => {
  return api.post(`/settings/itemMolecule/update`, data);
};

export const compositionDeleteApi = (data) => {
  return api.post(`/settings/itemMolecule/delete`, data);
};

export const compositionDocumentUploadApi = (data) => {
  return api.post(`/settings/itemMolecule/bulk/add`, data);
};

// Lead/Acquired Source APIs
export const leadSearchApi = (params) => {
  if (params) {
    return api.get(
      `/settings/acquiredSource/list/search?searchValue=${params}`
    );
  } else return api.get(`/settings/acquiredSource/list/search?searchValue=`);
};

export const leadCreateApi = (data) => {
  return api.post(`/acquiredSource/add`, data);
};

export const leadEditApi = (data) => {
  return api.post(`/settings/acquiredSource/update`, data);
};

export const leadDeleteApi = (data) => {
  return api.post(`/settings/acquiredSource/delete`, data);
};

export const leadDocumentUploadApi = (data) => {
  return api.post(`/settings/acquiredSource/bulk/add`, data);
};

// Payment/Payment Terms APIs
export const paymentSearchApi = (params) => {
  if (params) {
    return api.get(`/settings/paymentterms/list/search?searchValue=${params}`);
  } else return api.get(`/settings/paymentterms/list/search?searchValue=`);
};

export const paymentCreateApi = (data) => {
  return api.post(`/settings/paymentterms/add`, data);
};

export const paymentEditApi = (data) => {
  return api.post(`/settings/paymentterms/update`, data);
};

export const paymentDeleteApi = (data) => {
  return api.post(`/settings/paymentterms/delete`, data);
};

export const paymentDocumentUploadApi = (data) => {
  return api.post(`/settings/paymentterms/bulk/add`, data);
};

// 📦 Packing
export const packingSearchApi = (params) => {
  if (params) {
    return api.get(`/settings/packingt/list/search?searchValue=${params}`);
  } else return api.get(`/settings/packingt/list/search?searchValue=`);
};

export const packingCreateApi = (data) => {
  return api.post(`/settings/packing/add`, data);
};

export const packingEditApi = (data) => {
  return api.post(`/settings/packing/update`, data);
};

export const packingDeleteApi = (data) => {
  return api.post(`/settings/packing/delete`, data);
};

export const packingDocumentUploadApi = (data) => {
  return api.post(`/settings/packing/bulk/add`, data);
};

// 📦 Packing Type
export const packingTypeSearchApi = (params) => {
  if (params) {
    return api.get(`/settings/packingtype/list/search?searchValue=${params}`);
  } else return api.get(`/settings/packingtype/list/search?searchValue=`);
};

export const packingTypeCreateApi = (data) => {
  return api.post(`/settings/packingtype/add`, data);
};

export const packingTypeEditApi = (data) => {
  return api.post(`/settings/packingtype/update`, data);
};

export const packingTypeDeleteApi = (data) => {
  return api.post(`/settings/packingtype/delete`, data);
};

export const packingTypeDocumentUploadApi = (data) => {
  return api.post(`/settings/packingtype/bulk/add`, data);
};

// 📦 Carton
export const cartonSearchApi = (params) => {
  if (params) {
    return api.get(`/settings/cartontype/list/search?searchValue=${params}`);
  } else return api.get(`/settings/cartontype/list/search?searchValue=`);
};

export const cartonCreateApi = (data) => {
  return api.post(`/settings/cartontype/add`, data);
};

export const cartonEditApi = (data) => {
  return api.post(`/settings/cartontype/update`, data);
};

export const cartonDeleteApi = (data) => {
  return api.post(`/settings/cartontype/delete`, data);
};

export const cartonDocumentUploadApi = (data) => {
  return api.post(`/settings/cartontype/bulk/add`, data);
};

// Party/Party Category APIs
export const partySearchApi = (params) => {
  if (params) {
    return api.get(`/settings/partyType/list/search?searchValue=${params}`);
  } else return api.get(`/settings/partyType/list/search?searchValue=`);
};

export const partyCreateApi = (data) => {
  return api.post(`/settings/partyType/add`, data);
};

export const partyEditApi = (data) => {
  return api.post(`/settings/partyType/update`, data);
};

export const partyDeleteApi = (data) => {
  return api.post(`/settings/partyType/delete`, data);
};

export const partyDocumentUploadApi = (data) => {
  return api.post(`/settings/partyType/bulk/add`, data);
};
//

// ================== PARTY CATEGORY ==================
export const partyCategorySearchApi = (params) => {
  if (params) {
    return api.get(`/settings/partyCategory/list/search?searchValue=${params}`);
  } else return api.get(`/settings/partyCategory/list/search?searchValue=`);
};

export const partyCategoryCreateApi = (data) => {
  return api.post(`/settings/partyCategory/add`, data);
};

export const partyCategoryEditApi = (data) => {
  return api.post(`/settings/partyCategory/update`, data);
};

export const partyCategoryDeleteApi = (data) => {
  return api.post(`/settings/partyCategory/delete`, data);
};

export const partyCategoryDocumentUploadApi = (data) => {
  return api.post(`/settings/partyCategory/bulk/add`, data);
};

// ================== PARTY GROUP ==================
export const partyGroupSearchApi = (params) => {
  if (params) {
    return api.get(`/settings/partyGroup/list/search?searchValue=${params}`);
  } else return api.get(`/settings/partyGroup/list/search?searchValue=`);
};

export const partyGroupCreateApi = (data) => {
  return api.post(`/settings/partyGroup/add`, data);
};

export const partyGroupEditApi = (data) => {
  return api.post(`/settings/partyGroup/update`, data);
};

export const partyGroupDeleteApi = (data) => {
  return api.post(`/settings/partyGroup/delete`, data);
};

export const partyGroupDocumentUploadApi = (data) => {
  return api.post(`/settings/partyGroup/bulk/add`, data);
};

//LOCATION
// Country
export const countrySearchApi = (params) => {
  if (params) {
    return api.get(`/settings/country/list/search?searchValue=${params}`);
  } else return api.get(`/settings/country/list/search?searchValue=`);
};

export const countryCreateApi = (data) => {
  return api.post(`/settings/country/add`, data);
};

export const countryEditApi = (data) => {
  return api.post(`/settings/country/update`, data);
};

export const countryDeleteApi = (data) => {
  return api.post(`/settings/country/delete`, data);
};

export const countryDocumentUploadApi = (data) => {
  return api.post(`/settings/country/bulk/add`, data);
};

// Region
export const regionSearchApi = (params) => {
  if (params) {
    return api.get(`/settings/region/list/search?searchValue=${params}`);
  } else return api.get(`/settings/region/list/search?searchValue=`);
};

export const regionCreateApi = (data) => {
  return api.post(`/settings/region/add`, data);
};

export const regionEditApi = (data) => {
  return api.post(`/settings/region/update`, data);
};

export const regionDeleteApi = (data) => {
  return api.post(`/settings/region/delete`, data);
};

export const regionDocumentUploadApi = (data) => {
  return api.post(`/settings/region/bulk/add`, data);
};

// State
export const stateSearchApi = (params) => {
  if (params) {
    return api.get(`/settings/state/list/search?searchValue=${params}`);
  } else return api.get(`/settings/state/list/search?searchValue=`);
};

export const stateCreateApi = (data) => {
  return api.post(`/settings/state/add`, data);
};

export const stateEditApi = (data) => {
  return api.post(`/settings/state/update`, data);
};

export const stateDeleteApi = (data) => {
  return api.post(`/settings/state/delete`, data);
};

export const stateDocumentUploadApi = (data) => {
  return api.post(`/settings/state/bulk/add`, data);
};

// District
export const districtSearchApi = (params) => {
  if (params) {
    return api.get(`/settings/district/list/search?searchValue=${params}`);
  } else return api.get(`/settings/district/list/search?searchValue=`);
};

export const districtCreateApi = (data) => {
  return api.post(`/settings/district/add`, data);
};

export const districtEditApi = (data) => {
  return api.post(`/settings/district/update`, data);
};

export const districtDeleteApi = (data) => {
  return api.post(`/settings/district/delete`, data);
};

export const districtDocumentUploadApi = (data) => {
  return api.post(`/settings/district/bulk/add`, data);
};

// City
export const citySearchApi = (params) => {
  if (params) {
    return api.get(`/settings/city/list/search?searchValue=${params}`);
  } else return api.get(`/settings/city/list/search?searchValue=`);
};

export const cityCreateApi = (data) => {
  return api.post(`/settings/city/add`, data);
};

export const cityEditApi = (data) => {
  return api.post(`/settings/city/update`, data);
};

export const cityDeleteApi = (data) => {
  return api.post(`/settings/city/delete`, data);
};

export const cityDocumentUploadApi = (data) => {
  return api.post(`/settings/city/bulk/add`, data);
};

// Area
export const areaSearchApi = (params) => {
  if (params) {
    return api.get(`/settings/area/list/search?searchValue=${params}`);
  } else return api.get(`/settings/area/list/search?searchValue=`);
};

export const areaCreateApi = (data) => {
  return api.post(`/settings/area/add`, data);
};

export const areaEditApi = (data) => {
  return api.post(`/settings/area/update`, data);
};

export const areaDeleteApi = (data) => {
  return api.post(`/settings/area/delete`, data);
};

export const areaDocumentUploadApi = (data) => {
  return api.post(`/settings/area/bulk/add`, data);
};

//LOCATION

// Specialization APIs
export const specializationSearchApi = (params) => {
  if (params) {
    return api.get(
      `/settings/specialization/list/search?searchValue=${params}`
    );
  } else return api.get(`/settings/specialization/list/search?searchValue=`);
};

export const specializationCreateApi = (data) => {
  return api.post(`/settings/specialization/add`, data);
};

export const specializationEditApi = (data) => {
  return api.post(`/settings/specialization/update`, data);
};

export const specializationDeleteApi = (data) => {
  return api.post(`/settings/specialization/delete`, data);
};

export const specializationDocumentUploadApi = (data) => {
  return api.post(`/settings/specialization/bulk/add`, data);
};

// Sub Special/Sub-Specialization APIs
export const subSpecialSearchApi = (params) => {
  if (params) {
    return api.get(
      `/settings/subspecialization/list/search?searchValue=${params}`
    );
  } else return api.get(`/settings/subspecialization/list/search?searchValue=`);
};

export const subSpecialCreateApi = (data) => {
  return api.post(`/settings/subspecialization/add`, data);
};

export const subSpecialEditApi = (data) => {
  return api.post(`/settings/subspecialization/update`, data);
};

export const subSpecialDeleteApi = (data) => {
  return api.post(`/settings/subspecialization/delete`, data);
};

export const subSpecialDocumentUploadApi = (data) => {
  return api.post(`/settings/subspecialization/bulk/add`, data);
};

// Insurance/Insurance Provider APIs
export const insuranceSearchApi = (params) => {
  if (params) {
    return api.get(
      `/settings/insuranceprovider/list/search?searchValue=${params}`
    );
  } else return api.get(`/settings/insuranceprovider/list/search?searchValue=`);
};

export const insuranceCreateApi = (data) => {
  return api.post(`/settings/insuranceprovider/add`, data);
};

export const insuranceEditApi = (data) => {
  return api.post(`/settings/insuranceprovider/update`, data);
};

export const insuranceDeleteApi = (data) => {
  return api.post(`/settings/insuranceprovider/delete`, data);
};

export const insuranceDocumentUploadApi = (data) => {
  return api.post(`/settings/insuranceprovider/bulk/add`, data);
};
//

// DATA SETUP
